import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { TransitionGroup, Portal, Message, Icon, Button } from 'semantic-ui-react';

import { MESSAGE_CONFIG } from './constants';

import './styles.css';

class MessageComponent extends PureComponent {
  static propTypes = {
    type: PropTypes.string,
    message: PropTypes.string,
    messageId: PropTypes.number,
    removeMessageById: PropTypes.func,
  };

  static defaultProps = {
    type: null,
    message: null,
    messageId: null,
  };

  componentDidUpdate() {
    const { messageId } = this.props;

    /* istanbul ignore else */
    if (messageId) {
      this.setNewMessageTTL();
    }
  }

  setNewMessageTTL = () => {
    const { type, messageId, removeMessageById } = this.props;
    const config = MESSAGE_CONFIG[type];

    setTimeout(removeMessageById, config.ttl, messageId);
  };

  getNewMessage = () => {
    const { type, message, messageId } = this.props;
    const config = MESSAGE_CONFIG[type];

    return (
      <div key={messageId} styleName="message-message">
        <Message icon color={config.color}>
          <Button
            id={`message-dismiss-${messageId}`}
            tabIndex={0}
            styleName="message-close-wrapper"
            onClick={this.getCloseMessageClickable()}
            onKeyPress={this.getCloseMessageClickable()}
          >
            <Icon
              name="remove"
              size="large"
              color={config.color}
              styleName="message-close-icon"
            />
          </Button>
          <Icon name={config.icon} />
          <Message.Content>
            <Message.Header>{ type }</Message.Header>
            { message }
          </Message.Content>
        </Message>
      </div>
    );
  };

  getCloseMessageClickable = () => {
    const { messageId } = this.props;

    return () => {
      this.props.removeMessageById(messageId);
    };
  };

  render() {
    const { messageId } = this.props;

    return (
      <Portal open>
        <TransitionGroup animation="drop" duration={300}>
          { messageId
            ? this.getNewMessage()
            : null
          }
        </TransitionGroup>
      </Portal>
    );
  }
}

export default MessageComponent;



// WEBPACK FOOTER //
// ./src/app/components/Message/index.js